import { Injectable, inject } from '@angular/core';
import { CoreConfig, EnvironmentInfo } from '../interfaces/core-config';
import { CORE_APP_CONFIG } from '../utils/config.constants';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private _config: CoreConfig = inject(CORE_APP_CONFIG);
  private _environmentInfo: EnvironmentInfo = { ...this._config.environmentInfo };

  baseApiUrl() {
    return this._environmentInfo.baseApiUrl;
  }

  clientId() {
    return this._environmentInfo.clientId;
  }

  clientSecret() {
    return this._environmentInfo.clientSecret;
  }

  ciamClientId() {
    return this._environmentInfo.ciamClientId ?? '';
  }

  ciamBaseUrl() {
    return this._environmentInfo.ciamBaseUrl ?? '';
  }

  ciamScope() {
    return this._environmentInfo.ciamScope ?? '';
  }

  ciamTokenAuthHeader() {
    return this._environmentInfo.ciamTokenAuthHeader ?? '';
  }

  environmentInfo() {
    return { ...this._environmentInfo };
  }
}
